export default "__VITE_ASSET__B0CjUAq9__"